import R from 'app/assets/R'
import { ENV_CONFIG } from 'app/common/config'
import { GenderEnum, Priority } from 'parkway-web-common'

export type CategoryType = 'apps'

interface Category {
  name: CategoryType
  title: string
}

export const categoriesList: Category[] = [
  {
    name: 'apps',
    title: 'common',
  },
]

export interface Component {
  name: string
  title: string
  url: string
  categories: CategoryType[]
  keywords: string[]
}

export const configComponents: Component[] = [
  {
    name: 'Home',
    title: 'medical-dashboard.protein',
    url: `/home`,
    categories: ['apps'],
    keywords: ['home', 'apps', 'statistics'],
  },
]

export const defineColorByPriority = (priority: Priority): string => {
  switch (priority) {
    case Priority.INFO:
      return 'var(--primary-color)'
    case Priority.LOW:
      return 'var(--success-color)'
    case Priority.MEDIUM:
      return 'var(--warning-color)'
    case Priority.HIGH:
      return 'var(--error-color)'
    default:
      return 'var(--success-color)'
  }
}

export const URL_DOWNLOAD_EXAMPLE = {}

export enum TreatmentGroupEnum {}

export const FORMAT_DD_MM_YYYY_HH_MM_SS = 'DD/MM/YYYY HH:mm:ss'
export const FORMAT_DD_MM_YYYY_HH_MM = 'DD/MM/YYYY HH:mm'

export const ListTotal = []

export const AppointmentStatusDone = {
  background: '#F3F4F6',
  border: '#DADEE3',
  status: 8,
  label: 'Đã hoàn thành',
  total: 0,
}

export const AppointmentStatusCancel = {
  background: '#FDE9FF',
  border: '#FD44B3',
  label: 'Hủy lịch hẹn',
  total: 0,
  status: 7,
}

export const ListAppointmentStatus = []

export const ALL_KEY = 'all'

export const firebaseConfig = {
  apiKey: ENV_CONFIG.FIREBASE_API_KEY,
  authDomain: ENV_CONFIG.FIREBASE_AUTH_DOMAIN,
  projectId: ENV_CONFIG.FIREBASE_PROJECT_ID,
  storageBucket: ENV_CONFIG.FIREBASE_STORAGE_BUDGET,
  messagingSenderId: ENV_CONFIG.FIREBASE_MESSAGE_SENDER_ID,
  appId: ENV_CONFIG.FIREBASE_APP_ID,
  measurementId: ENV_CONFIG.FIREBASE_MEASUREMENT_ID,
}

export const GET_GENDER_I18N_KEY = {
  [GenderEnum.F]: R.strings.female,
  [GenderEnum.M]: R.strings.male,
  [GenderEnum.Other]: R.strings.other,
}

export const _DEV_ = process.env?.NODE_ENV === 'development'

export const APPOINTMENT = 'APPOINTMENT'
